import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { RTALookupItem } from 'src/app/shared/models/rta-lookup.model';
import { SolarFormsRepositoryService } from './solar-forms-repository.service';

/**
 * Client-side wrapper for the RTA controlled-vocabulary endpoint
 * (/RTALookup/GetByDomain). Caches each domain for the lifetime of the
 * service instance to avoid repeated round trips within a single form load.
 * The backend also caches for 15 minutes.
 */
@Injectable({ providedIn: 'root' })
export class RTALookupService {
  private cache = new Map<string, Observable<RTALookupItem[]>>();

  constructor(private repo: SolarFormsRepositoryService) {}

  getByDomain(domain: string): Observable<RTALookupItem[]> {
    if (!domain) return of([]);
    const key = domain.toLowerCase();
    if (!this.cache.has(key)) {
      const request$ = this.repo.getRTALookupByDomain(domain).pipe(
        catchError(() => of<RTALookupItem[]>([])),
        shareReplay(1)
      );
      this.cache.set(key, request$);
    }
    return this.cache.get(key);
  }
}
